interface AwaitingParams {
  locale?: string;
}

export default function queryString(query = ""): AwaitingParams {
  if (!query.length) return {};
  return query
    .substring(1)
    .split("&")
    .reduce((acc, val) => {
      const [name, value] = val.split("=");
      return { ...acc, [name]: value };
    }, {});
}
